import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryConfig } from "../baseQueryConfig ";

export const supplierApi = createApi({
  reducerPath: "supplierApi",
  baseQuery: baseQueryConfig,
  tagTypes: ["supplier"],
  endpoints: (builder) => ({
    getSuppliers: builder.query({
      query: (companyId) => ({
        url: `supplier/companyId/${companyId}`,
        method: "GET",
      }),
      providesTags: ["supplier"],
    }),
    getEnabledSuppliers: builder.query({
      query: (companyId) => ({
        url: `supplier/companyId/${companyId}?status=enabled`,
        method: "GET",
      }),
      providesTags: ["supplier"],
    }),
    getAllSuppliers: builder.query({
      query: () => ({
        url: `supplier`,
        method: "GET",
      }),
      providesTags: ["supplier"],
    }),
    createSupplier: builder.mutation({
      query: (supplierData) => ({
        url: "supplier",
        method: "POST",
        body: supplierData,
      }),
      invalidatesTags: ["supplier"],
    }),
    updateSupplier: builder.mutation({
      query: ({ id, data }) => ({
        url: `supplier/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["supplier"],
    }),

    getSupplierByIdAndCompanyId: builder.query({
      query: ({ supplierId, companyId }) => ({
        url: `supplier/${supplierId}/${companyId}`,
        method: "GET",
      }),
      providesTags: ["supplier"],
    }),
    disableSupplier: builder.mutation({
      query: (id) => ({
        url: `supplier/disable/${id}`,
        method: "PATCH",
      }),
      invalidatesTags: ["supplier"],
    }),
    enableSupplier: builder.mutation({
      query: (id) => ({
        url: `supplier/enable/${id}`,
        method: "PATCH",
      }),
      invalidatesTags: ["supplier"],
    }),
    createUserSupplier: builder.mutation({
      query: ({ supplierId, userData }) => ({
        url: `supplier/${supplierId}/users`, // correspond au controller NestJS
        method: "POST",
        body: userData,
      }),
      invalidatesTags: ["supplier"],
    }),

    getUsersSuppliers: builder.query({
      query: ({ supplierId, companyId }) => ({
        url: `supplier/supplier/user/supplier?idSupplier=${supplierId}&companyId=${companyId}`,
        method: "GET",
      }),
      providesTags: ["supplier"],
    }),
  }),
});

export const {
  useGetSuppliersQuery,
  useCreateSupplierMutation,
  useUpdateSupplierMutation,
  useDisableSupplierMutation,
  useGetSuppliersByCompanyIdQuery,
  useGetSupplierByIdAndCompanyIdQuery,
  useGetAllSuppliersQuery,
  useEnableSupplierMutation,
  useGetEnabledSuppliersQuery,
  useCreateUserSupplierMutation,
  useGetUsersSuppliersQuery,
} = supplierApi;

export default supplierApi;
